import React from "react";

import { LibraryView } from "common/constants";
import { LibraryPaneLayout } from "js/editor/PresentationLibrary/LibraryPaneLayout";
import { TeamTemplatesPane } from "js/editor/PresentationLibrary/TeamTemplatesPane";
import { LibraryTemplatesLayoutProps, TemplateCreationClickShield } from "js/editor/PresentationLibrary/libraryTemplatesPaneShared";

function LibraryTeamTemplatesPaneLayout({
    sideBarWidth,
    onResizeSidebar,
    showNavigationSidebar = true,
    onCreate,
    isCreatingPresentation,
}: LibraryTemplatesLayoutProps) {
    return (
        <LibraryPaneLayout
            libraryView={LibraryView.TEMPLATES}
            onResizeSidebar={onResizeSidebar}
            showNavigationSidebar={showNavigationSidebar}
            sideBarWidth={sideBarWidth}
        >
            <TemplateCreationClickShield visible={isCreatingPresentation} />
            <TeamTemplatesPane onCreate={onCreate} showManageTemplatesLink />
        </LibraryPaneLayout>
    );
}

export const LibraryTeamTemplatesPaneInner = LibraryTeamTemplatesPaneLayout;
